<div>
  <div class="header">
    <button disabled mat-icon-button (click)="toggleColors()" class="color-button">
      <mat-icon>palette</mat-icon>
    </button>
    <h4 class="chart-title">{{ config?.name }}</h4>
  </div>
  <div class="body">
    <svg #chartBody class="{{config.id}}-chart"></svg>
  </div>
</div>
